import { api } from '../../services/api'
import { showSuccess, showError } from '../misc/misc.actions'
import Firebase from '../../components/Firebase'
import { sendPasswordResetEmail } from 'firebase/auth'

export const getAllStaff = () => {
	return (dispatch) => {
		dispatch({ type: 'GET_STAFF' })

		return api
			.get(`/staff-list`)
			.then((response) => {
				dispatch({ type: 'GET_STAFF_SUCCESS', staffList: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_STAFF_FAIL' })
			})
	}
}

export const getStaffById = (staffId) => {
	return (dispatch) => {
		dispatch({ type: 'GET_STAFF' })

		return api
			.get(`/team/${staffId}`)
			.then((response) => {
				dispatch({ type: 'SET_SELECTED_STAFF', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_STAFF_FAIL' })
			})
	}
}

export const uploadStaffProfilePhoto = (staffId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_STAFF' })

		return api
			.post(`/team/${staffId}/profile/image`, payload)
			.then((response) => {
				dispatch(showSuccess('Staff profile image updated successfully.'))
				dispatch({ type: 'UPDATE_STAFF_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				dispatch(showError('An error occured while updating the profile image.'))
				dispatch({
					type: 'UPDATE_STAFF_FAIL',
					payload: e
				})
			})
	}
}

export const updateStaff = (staffId, updates, oldStaffModel) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_STAFF' })

		return api
			.patch(`/team/${staffId}`, updates)
			.then((response) => {
				dispatch(showSuccess(`Staff updated!`))
				dispatch({ type: 'UPDATE_STAFF_SUCCESS', payload: response.data })

				const needsPasswordReset = []
				if (response.data?.uid_map?.length) {
					response.data.uid_map.forEach((uid) => {
						let exists = oldStaffModel?.uid_map?.find(
							(oldUid) => oldUid.app === uid.app && oldUid.uid === uid.uid
						)
						if (!exists) needsPasswordReset.push(uid)
					})
				}

				console.log(needsPasswordReset)

				const user = {
					...response.data,
					uid_map: needsPasswordReset
				}

				sendPasswordEmails(user)
			})
			.catch((e) => {
				console.log(e, e.response)
				let error = e && e.data ? e.data : null
				dispatch(showError(error || 'Error updating staff'))
				dispatch({
					type: 'UPDATE_STAFF_FAIL',
					payload: error || 'An error occured while updating the selected staff.'
				})
			})
	}
}

export const addStaff = (staffMember, history, facilityId) => {
	return (dispatch) => {
		dispatch({ type: 'ADD_STAFF_MEMBER' })

		return api
			.post(`/team/create`, staffMember)
			.then((response) => {
				dispatch(showSuccess('Staff Added Succesfully.'))
				dispatch({ type: 'ADD_STAFF_SUCCESS', payload: response.data })

				if (response.data && response.data._id && history && facilityId) {
					if (response.data?.uid_map?.length) sendPasswordEmails(response.data)

					console.log('here')
					setTimeout(() => {
						history.push(`/facilities/${facilityId}/team/${response.data._id}`)
					}, 500)
				}
			})
			.catch((e) => {
				dispatch(showError('Error adding staff.'))
				dispatch({ type: 'ADD_STAFF_FAIL' })
			})
	}
}

const sendPasswordEmails = async (user) => {
	const email = user.email

	for (let uid of user.uid_map) {
		if (uid.app === 'team') {
			await sendPasswordResetEmail(Firebase.tmAuth, email)
		} else if (uid.app === 'admin') {
			await sendPasswordResetEmail(Firebase.auth, email)
		}
	}
}
